// @mui material components
import { Card, Grid } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

import React from "react";
import { useNavigate } from "react-router-dom";

function PayeerHeader() {
  const navigate = useNavigate();
  return (
    <MDBox pt={3} pb={3}>
      <Card>
        <MDBox p={3}>
          <MDBox>
            <MDTypography variant="h4">Payeer</MDTypography>
          </MDBox>
          <MDBox mt={1}>
            <MDTypography variant="h6" fontWeight="light">
              Deposit and withdraw payeer funds instantly and securely.
            </MDTypography>
          </MDBox>
          <MDBox mt={5}>
            <MDBox display="flex" justifyContent="flex-start">
              <Grid container spacing={3}>
                <Grid item>
                  <MDButton
                    color="success"
                    variant="outlined"
                    onClick={() => {
                      navigate("/payeer/buy");
                    }}
                    sx={{ align: "right" }}
                  >
                    Deposit
                  </MDButton>
                </Grid>
                <Grid item>
                  <MDButton
                    color="error"
                    variant="outlined"
                    onClick={() => {
                      navigate("/payeer/sell");
                    }}
                    sx={{ align: "right" }}
                  >
                    Withdraw
                  </MDButton>
                </Grid>
                <Grid item>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={() => {
                      navigate("/switch/request-money");
                    }}
                    sx={{ align: "right" }}
                  >
                    Request
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </MDBox>
  );
}

export default PayeerHeader;
